import { apiCall } from "services/api";

export const login = async (data) => {
  const response = await apiCall({
    url: "/v1/auth/login",
    data,
    method: "POST",
    headers: {},
  });
  return response;
};

export const sendForgotPasswordEmail = async (data) => {
  const response = await apiCall({
    url: "/v1/auth/password/reset",
    data,
    method: "POST",
    headers: {},
  });
  return response;
};

export const logout = async () => {
  const response = await apiCall({
    url: "/v1/auth/logout",
    method: "POST",
  });
  return response;
};
